import React from "react";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import "./sliderInfo.css";
import { Link } from "react-router-dom";
import {EMPLOYEE_ENUM, getEmployee} from "../../models/employees";

export const SliderInfo = () => {
  return (
    <div className="sliderInfo">
      <div className="top">
        <div className="row">
          <h1>CJ´s BARBERSHOP</h1>
          <hr />
        </div>
      </div>
      <div className="bottom">
        <div className="row">
          <LocationOnIcon className="mui" />
          <span>Špindlerova třída 687, Roudnice nad Labem</span>
        </div>

        <div className="row">
          <table className="openingHours">
              {getEmployee(EMPLOYEE_ENUM.Sam).workSchedules.map(({dayName, openingHours, isOpen}) => (
                <tr key={dayName} className={isOpen ? "" : "closed"}>
                  <td className="day">{dayName}:</td>
                  <td className="hours">
                    {isOpen ? `${openingHours.open} - ${openingHours.close}` : "zavřeno"}
                  </td>
                </tr>
              ))}
          </table>
        </div>

        <div className="row">
          <LocalPhoneIcon className="mui" />
          <span>777 606 447</span>
        </div>
        <Link className="link" to="/rezervace">
          <button className="reservationBtn"> ONLINE REZERVACE</button>
        </Link>
      </div>
    </div>
  );
};
